import { render } from "./milestone-planner-for-visitors.view.vue?vue&type=template&id=52ac8b75&ts=true"
import script from "./milestone-planner-for-visitors.view.vue?vue&type=script&lang=ts"
export * from "./milestone-planner-for-visitors.view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__